import React from 'react'
import * as S from '../styled'

interface InProgressRatingModalProps {
  isVisible: boolean
  onClose: () => void
  onStartNewRating: () => void
}

const InProgressRatingModal: React.FC<InProgressRatingModalProps> = ({
  isVisible,
  onClose,
  onStartNewRating,
}) => {
  if (!isVisible) return null

  return (
    <S.ModalOverlay>
      <S.ModalBackdrop onClick={onClose} />
      <S.ModalContent>
        <S.ModalTitle>Start new rating</S.ModalTitle>
        <S.ModalDescription>
          There are currently ratings in progress. Are you sure you want to
          start a new rating?
        </S.ModalDescription>

        <S.ModalButtonContainer>
          <S.CancelButton onClick={onClose}>Cancel</S.CancelButton>
          <S.DestructiveButton onClick={onStartNewRating}>
            Start new rating
          </S.DestructiveButton>
        </S.ModalButtonContainer>
      </S.ModalContent>
    </S.ModalOverlay>
  )
}

export default InProgressRatingModal
